import React, { Component } from "react";
import {
  profile,
  alert,
  format_date,
  GET,
  POST,
  loading,
  Navbar,
  copyText,
  Status,
} from "../../components/CustomComponent.js";
export default class ConnectAPI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: profile.uid || "",
      full_name: profile.full_name || "",
      phone: profile.phone || "",
      password: "",
      confirm_password: "",

      current_password: "",

      client_id: profile?.broker?.entity_config?.client_id || "",
      client_ref_id: profile?.broker?.entity_config?.client_ref_id || "",
      client_secret: profile?.broker?.entity_config?.client_secret || "",
      x_apigw_api_id: profile?.broker?.entity_config?.x_apigw_api_id || "",
      expire_at: profile?.broker?.entity_config?.expire_at || "",
      ip_address: profile?.broker?.entity_config?.ip_address || "",
      count_request: profile?.broker?.entity_config?.count_request || "",
      link: profile?.broker?.entity_config?.link || "",
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get();
  }
  Get = async () => {
    const result = await GET("v1/admin/users/profile");
    if (result?.status) {
      localStorage.setItem("scp-profile", JSON.stringify(result.data));
      this.setState({
        client_id: result.data?.broker?.entity_config?.client_id || "",
        client_ref_id: result.data?.broker?.entity_config?.client_ref_id || "",
        client_secret: result.data?.broker?.entity_config?.client_secret || "",
        x_apigw_api_id: result.data?.broker?.entity_config?.x_apigw_api_id || "",
        expire_at: result.data?.broker?.entity_config?.expire_at || "",
        ip_address: result.data?.broker?.entity_config?.ip_address || "",
        count_request: result.data?.broker?.entity_config?.count_request || "",
        link: result.data?.broker?.entity_config?.link || "",
      });
    }
  };
  ExportCertificate = async () => {
    const {
      client_id,
      client_ref_id,
      client_secret,
      x_apigw_api_id,
      ip_address,
    } = this.state;
    if (!ip_address) {
      alert(
        "",
        "warning",
        "Warning",
        "There is no IP address for connecting to the API. Please contact the admin to add an IP address before requesting a certificate."
      );
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to request a certificate?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      const body = {
        client_id: client_id,
        client_ref_id: client_ref_id,
        client_secret: client_secret,
        "x-apigw-api-id": x_apigw_api_id,
        valid_days: this.getDaysUntilEndOfYear(),
        ip_address: ip_address,
      };
      const result = await POST("certificates/create", body);
      if (result?.status) {
        try {
          let base64 = result.data;

          // ✅ แก้ช่องว่างและตัวอักษรไม่ถูกต้องก่อน decode
          base64 = base64
            .replace(/ /g, "+")
            .replace(/%2B/g, "+")
            .replace(/\r?\n|\s/g, "");

          // แปลง Base64 → Binary
          const byteCharacters = atob(base64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // สร้าง Blob ZIP
          const blob = new Blob([byteArray], {
            type: "application/zip",
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "certificate.zip";
          a.click();
          URL.revokeObjectURL(url);
        } catch (err) {
          alert("The file you want to download was not found.");
          console.error(err);
        }
        alert(
          "#",
          "success",
          "Success",
          "Certificate request successful. certificate.zip has been downloaded. The unzip password has been sent to your registered email — use the email with the same reference shown on this page."
        );
        this.Get();
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  getDaysUntilEndOfYear() {
    const today = new Date();
    const currentYear = today.getFullYear();

    // ตั้งวันหมดอายุเป็น 30 มิถุนายนของปีปัจจุบัน
    let expiryDate = new Date(currentYear, 5, 30); // เดือน 5 = มิถุนายน (index เริ่มจาก 0)

    // ถ้าน้อยกว่า 30 วัน ให้เลื่อนหมดอายุไปอีกปี
    const diffTime = expiryDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 30) {
      expiryDate = new Date(currentYear + 1, 5, 30); // 30 มิ.ย. ปีหน้า
    }

    const finalDiffTime = expiryDate - today;
    const finalDiffDays = Math.ceil(finalDiffTime / (1000 * 60 * 60 * 24));

    return finalDiffDays;
  }
  render() {
    const {
      client_id,
      client_ref_id,
      client_secret,
      x_apigw_api_id,
      expire_at,
      ip_address,
      count_request,
      link,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Integration</div>
                <div className="ar-title">API Information</div>
                <div className="ar-subtitle">Configure your API credentials</div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-11 col-lg-9 col-xl-9 col-xxl-7 mx-auto">
              <div className="ar-table-card p-3 mb-3">
                <div className="d-flex mb-3 align-items-center">
                  <div className="wpx-150 pr-label mb-0">client_id</div>
                  <div className="overflow-scroll w-100 me-3">
                    {client_id || ""}
                  </div>
                  <span
                    className="icon pointer pu-copy-link"
                    onClick={() => {
                      copyText(client_id || "");
                    }}
                  >
                    {"\uf0c5"}
                  </span>
                </div>
                <hr />
                <div className="d-flex mb-3 align-items-center">
                  <div className="wpx-150 pr-label mb-0">client_secret</div>
                  <div className="overflow-scroll w-100 me-3">
                    {client_secret || ""}
                  </div>
                  <span
                    className="icon pointer pu-copy-link"
                    onClick={() => {
                      copyText(client_secret || "");
                    }}
                  >
                    {"\uf0c5"}
                  </span>
                </div>
                <hr />
                <div className="d-flex mb-3 align-items-center">
                  <div className="wpx-150 pr-label mb-0">client_ref_id</div>
                  <div className="overflow-scroll w-100 me-3">
                    {client_ref_id || ""}
                  </div>
                  <span
                    className="icon pointer pu-copy-link"
                    onClick={() => {
                      copyText(client_ref_id || "");
                    }}
                  >
                    {"\uf0c5"}
                  </span>
                </div>
                <hr />
                <div className="d-flex mb-3 align-items-center">
                  <div className="wpx-150 pr-label mb-0">x-apigw-api-id</div>
                  <div className="overflow-scroll w-100 me-3">
                    {x_apigw_api_id || ""}
                  </div>
                  <span
                    className="icon pointer pu-copy-link"
                    onClick={() => {
                      copyText(x_apigw_api_id || "");
                    }}
                  >
                    {"\uf0c5"}
                  </span>
                </div>
                <hr />
                <div className="d-flex mb-3 align-items-center">
                  <div className="wpx-150 pr-label mb-0">Expired</div>
                  <div className="overflow-scroll w-100 me-3">
                    {expire_at
                      ? format_date(expire_at,"dd/mm/yyyy","en")
                      : "No certificate has been requested yet."}
                  </div>
                </div>
                <hr />
                <div className="d-flex mb-3 align-items-center">
                  <div className="wpx-150 pr-label mb-0">IP Address</div>
                  <div className="overflow-scroll w-100 me-3">
                    {ip_address ? ip_address.replaceAll(",", ", ") : ""}
                  </div>
                </div>
                <hr />
                <div className="d-flex mb-3 align-items-center">
                  <div className="wpx-150 pr-label mb-0">Endpoint</div>
                  <div className="overflow-scroll w-100 me-3">
                    {process.env.REACT_APP_ENPOINT_URL || ""}
                  </div>
                  <span
                    className="icon pointer pu-copy-link"
                    onClick={() => {
                      copyText(process.env.REACT_APP_ENPOINT_URL || "");
                    }}
                  >
                    {"\uf0c5"}
                  </span>
                </div>
              </div>
              <div className="ar-table-card p-3 p-md-4">
                {(() => {
                  // link = "<หมดเวลาดาวน์โหลด ms>:<zip base64>" ดาวน์โหลดซ้ำได้ 24 ชม. หลังขอ
                  const isReady = !!link && new Date().getTime() < Number(link.split(":")[0]);
                  // ส่วนที่ 3 ของ link = รหัสอ้างอิงที่อยู่ในหัวเรื่องอีเมลรหัสผ่านด้วย (ลิงก์เก่าไม่มี)
                  const certRef = link ? link.split(":")[2] || "" : "";
                  const used = Number(count_request) || 0;
                  const limitReached = used >= 10;
                  return (
                    <>
                      <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                        <div className="ar-table-title">Certificate</div>
                        {isReady ? Status("Ready to download", "success") : null}
                      </div>
                      <div className="text-secondary text-12 mb-3">
                        A certificate is required to connect to the API (mutual TLS).{" "}
                        <a href="/document-api?i=connect-api" className="text-decoration-none">
                          How to use it
                        </a>
                      </div>

                      <div className="tfa-steps mt-0 pt-0 border-0">
                        <div className="tfa-step">
                          <span className="tfa-num">1</span>
                          <div>
                            <div className="tfa-step-title">Request a certificate</div>
                            <div className="tfa-step-text">
                              certificate.zip downloads to your device right away.
                            </div>
                          </div>
                        </div>
                        <div className="tfa-step">
                          <span className="tfa-num">2</span>
                          <div>
                            <div className="tfa-step-title">Unzip it with the password from your email</div>
                            <div className="tfa-step-text">
                              We send the unzip password to your registered email address. Use the email
                              whose reference matches the one shown below.
                            </div>
                          </div>
                        </div>
                        <div className="tfa-step">
                          <span className="tfa-num">3</span>
                          <div>
                            <div className="tfa-step-title">Add the files to your project</div>
                            <div className="tfa-step-text">
                              Use certificate.pem and private.key when calling the API.
                            </div>
                          </div>
                        </div>
                      </div>

                      {isReady && (
                        <div className="tfa-setup d-block mt-3">
                          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-1">
                            <div className="fw-bold">Your certificate is ready</div>
                            {certRef && (
                              <div className="d-flex align-items-center gap-2">
                                <span className="pr-label mb-0">Reference</span>
                                <span className="tfa-key py-1 px-2">{certRef}</span>
                              </div>
                            )}
                          </div>
                          <div className="tfa-step-text mb-3">
                            Download it again until{" "}
                            <b>{format_date(Number(link.split(":")[0]), "dd/mm/yyyy hh:mm")}</b>{" "}
                            (24 hours after your request).{" "}
                            {certRef
                              ? <>The unzip password is in the email titled <b>"Your SwiftGoldPay Certificate (Ref: {certRef})"</b>.</>
                              : "The unzip password was sent to your email."}
                          </div>
                          <button
                            className="ar-btn-gold w-100 justify-content-center"
                    onClick={() => {
                      try {
                        let base64 = link.split(":")[1];

                        // ✅ แก้ช่องว่างและตัวอักษรไม่ถูกต้องก่อน decode
                        base64 = base64
                          .replace(/ /g, "+")
                          .replace(/%2B/g, "+")
                          .replace(/\r?\n|\s/g, "");

                        // แปลง Base64 → Binary
                        const byteCharacters = atob(base64);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                          byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);

                        // สร้าง Blob ZIP
                        const blob = new Blob([byteArray], {
                          type: "application/zip",
                        });
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = "certificate.zip";
                        a.click();
                        URL.revokeObjectURL(url);
                      } catch (err) {
                        alert("","warning","Warning","The file you want to download was not found.");
                        console.error(err);
                      }
                    }}
                          >
                            <span className="icon me-2">{"\uf019"}</span>Download certificate.zip
                          </button>
                        </div>
                      )}

                      <div className="mt-3">
                        {limitReached ? (
                          <div className="text-danger text-12">
                            You have used all 10 certificate requests. Please contact the admin to reset the requests.
                          </div>
                        ) : (
                          <>
                            <button
                              className={`${isReady ? "tfa-btn-outline" : "ar-btn-gold"} w-100 justify-content-center`}
                              onClick={() => {
                                this.ExportCertificate();
                              }}
                            >
                              <span className="icon me-2">{"\uf0fe"}</span>
                              {isReady ? "Request a new certificate" : "Request certificate"}
                            </button>
                            <div className="tfa-step-text text-center mt-2">
                              {isReady
                                ? "A new request creates a new certificate and a new password. Your previous certificate keeps working until it expires. "
                                : ""}
                              Requests used: {used}/10
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
